import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {SERVER_API_URL} from "@app/app.constants";

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient) {}

  sendContactEmail(contactData: any): Observable<any> {
    return this.http.post(SERVER_API_URL + `contact`, contactData, {
      observe: 'response',
    });
  }

  putUser(data: any): Observable<any> {
    return this.http.put(SERVER_API_URL + `users `, data);
  }

  deleteUser(data: any): Observable<any> {
    let options = {
      headers: { Authorization: '' },
      body: data,
    };

    return this.http.delete(SERVER_API_URL + `users `, options);
  }
  getUserById(id: number): Observable<any> {
    return this.http.get(`${SERVER_API_URL}users/${id}`);
  }

  getUserPropertiesById(id: number): Observable<any> {
    return this.http.get(`${SERVER_API_URL}users/${id}/properties`);
  }

  sendEmailToDelete(data: any): Observable<any> {
    return this.http.post(`${SERVER_API_URL}users/contact/delete-user`, data);
  }

  create(data: any): Observable<any> {
    data.page = {
      url: window.location.href,
      title: document.title,
    };
    return this.http.post(SERVER_API_URL + `public/users`, data);
  }

  getConsents(hash: string): Observable<any> {
    return this.http.get(SERVER_API_URL + `public/users/consents/${hash}`);
  }
  
  manageConsents(data: any): Observable<any> {
    return this.http.post(SERVER_API_URL + `public/users/manage-consents`, data);
  }
  
  validateUser(idUser: any): Observable<any> {
    return this.http.put(SERVER_API_URL + `users/${idUser}/validate-user`, {});
  }

  updateUserProfile(idUser:any, email: string, data: any): Observable<any> {
    return this.http.put(SERVER_API_URL + `users/investor-profile`, {
      id_user: idUser,
      email: email,
      formPerfilInversor: data
    });
  }
}
